import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import ExperienceWrapper from './Experience/ExperienceWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ExperienceWrapper />
  </React.StrictMode>
);
